import {Action} from "redux";
import {combineReducers} from "redux";
import {isType} from "typescript-fsa";
import {session} from "@neolab/ice-client";

import {
  usernameChanged,
  passwordChanged,
  authProviderChanged,
} from "./Login.actions";


const username = (state: string = '', action: Action): string => {
  if (isType(action, usernameChanged))
    return action.payload;

  if (isType(action, session.started))
    return '';

  return state;
};

const password = (state: string = '', action: Action): string => {
  if (isType(action, passwordChanged))
    return action.payload;

  if (isType(action, session.started))
    return '';

  return state;
};


const authProvider = (state: string = '', action: Action): string => {
  if (isType(action, authProviderChanged))
    return action.payload;

  return state;
};

export interface LoginState {
  authProvider: string;
  username: string;
  password: string;
}

export default combineReducers<LoginState>({
  authProvider,
  username,
  password,
});




// WEBPACK FOOTER //
// ./~/tslint-loader!./src/routes/login/reducer.ts